import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-tab-button',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './tab-button.component.html',
  styleUrl: './tab-button.component.css'
})
export class TabButtonComponent {
  @Input() label: string = '';
  @Input() isActive: boolean = false;
  @Input() link: string = '';
}
